export default __webpack_public_path__ + "static/media/banner-1.3de6b58a.jpg";